import DashboardBanner from '@/components/dashboard/banner';
import CardAcoesRapidas from '@/components/dashboard/card-acoes-rapidas';
import { CardOutrosSistemas } from '@/components/dashboard/cards/outros-sistemas/card-outros-sistemas';
import PesquisaSatisfacaoCard from '@/components/dashboard/cards/pesquisa-satisfacao';
import CardSecullumRh from '@/components/dashboard/cards/secullum-rh/card-secullum-rh';
import DashboardNotifications from '@/components/dashboard/notifications/dashboard-notifications';
import DashboardPopup from '@/components/dashboard/popup';
import Solicitacoes from '@/components/dashboard/solicitacoes';
import { fetchClient } from '@/lib/api';
import { createFileRoute } from '@tanstack/react-router';
import { useRef } from 'react';
import { flushSync } from 'react-dom';
import { useLocalStorage } from 'react-use';

export const Route = createFileRoute('/__authenticated/dashboard')({
  loader: async () => {
    const { data } = await fetchClient.GET('/dashboard');
    return data;
  },
  component: RouteComponent,
});

function RouteComponent() {
  const [showSolicitacoes, setShowSolicitacoes] = useLocalStorage(
    'showSolicitacoes',
    false,
  );

  const solicitacoesRef = useRef<HTMLDivElement>(null);

  function scrollToSolicitacoes() {
    solicitacoesRef.current?.scrollIntoView({
      block: 'center',
    });
  }

  const data = Route.useLoaderData();
  const bannerConfigs = data?.banner.configs ?? {};
  const popupConfigs = data?.popup.configs ?? {};
  const notifications = data?.notifications ?? [];

  return (
    <main className="flex-1 bg-background">
      <DashboardPopup configs={popupConfigs} />
      <DashboardBanner configs={bannerConfigs} />

      <div className="mx-auto flex w-full max-w-6xl flex-col gap-6 px-4 py-6 pb-15">
        <DashboardNotifications notifications={notifications} />

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {data?.cards.secullumRh != null && (
            <CardSecullumRh data={data.cards.secullumRh} />
          )}

          <CardOutrosSistemas />

          {data?.cards.pesquisaSatisfacao != null && (
            <PesquisaSatisfacaoCard data={data.cards.pesquisaSatisfacao} />
          )}

          <CardAcoesRapidas
            showSolicitacoes={showSolicitacoes ?? false}
            onChangeShowSolicitacoes={value => {
              flushSync(() => {
                setShowSolicitacoes(value);
              });

              if (value) {
                scrollToSolicitacoes();
              }
            }}
            className="lg:col-span-3"
          />
        </div>

        {showSolicitacoes && (
          <div ref={solicitacoesRef}>
            <Solicitacoes />
          </div>
        )}
      </div>
    </main>
  );
}
